import { makeAutoObservable } from 'mobx'
import { createContext } from 'react'

export class CommentItemStore {
  private _showReplyField: string = ''

  public get showReplyField() {
    return this._showReplyField
  }

  public set showReplyField(id: string) {
    this._showReplyField = id
  }

  public constructor() {
    makeAutoObservable(this)
  }
}

export interface CommentsContextProperties {
  darkMode: boolean
  onEdit: (contextKey: string, commentId: string, text: string) => void
  onDelete: (contextKey: string, commentId: string) => void
  onReply: (contextKey: string, commentId: string, text: string) => void
  commentItemStore: CommentItemStore
  scrollToCommentId: string | undefined
}

export const CommentsContext = createContext<CommentsContextProperties>({
  darkMode: false,
  onEdit(contextKey, commentId, text) {},
  onDelete(contextKey, commentId) {},
  onReply(contextKey, commentId, text) {},
  commentItemStore: new CommentItemStore(),
  scrollToCommentId: undefined,
})
